angular.module('FlexyBeautyApp.services').factory('PaymentService_Resource', ['$resource', '$location',
  function ($resource, $location) {
    let baseUrl = $location.protocol() + '://' + $location.host() + ($location.port() && ':' + $location.port()) + '/'
    return $resource(baseUrl + 'rest/payment-service/', {}, {
      updateIban: {
        method: 'POST',
        isArray: false,
        url: baseUrl + 'rest/payment-service/update-iban'
      },
      getNeedUpdateMangopay: {
        method: 'GET',
        isArray: false,
        url: baseUrl + 'rest/payment-service/check-need-update-mangopay'
      },
      enrollUser: {
          method: 'POST',
          url: baseUrl + 'rest/payment-service/enrollUser'
      }
    })
  }
])

angular.module('FlexyBeautyApp.services').factory('PaymentServiceSrv', ['$location', 'PaymentService_Resource', '$window',
  function ($location, PaymentService_Resource, $window) {
    let paymentServiceSrv = {}

    paymentServiceSrv.updateBankAccount = function (company, bankAccount, successFunction, errorFunction) {
      let paymentServiceResource = new PaymentService_Resource()

      paymentServiceResource.ownerName = bankAccount.ownerName;
      paymentServiceResource.ownerAddress = bankAccount.ownerAddressLine1;
      paymentServiceResource.ownerPostalCode = bankAccount.ownerPostalCode;
      paymentServiceResource.ownerCity = bankAccount.ownerCity;
      paymentServiceResource.ownerCountry = bankAccount.ownerCountry;
      paymentServiceResource.iban = bankAccount.bankAccountDetails.iban;

      paymentServiceResource.$updateIban({},
        function (companyPaymentData) {
          if (companyPaymentData.scaAction.redirectUrl) {
            let currentDomain = $location.protocol() + '://' + $location.host();
            let encodedDomain = encodeURIComponent(currentDomain);
            let redirectUrl = companyPaymentData.scaAction.redirectUrl + '&returnUrl=' + encodedDomain;
            $window.location.href = redirectUrl;
          }
          if (companyPaymentData && company.companyPaymentData) {
            company.companyPaymentData.bankAccountId = companyPaymentData.bankAccountId
            company.companyPaymentData.customerId = companyPaymentData.customerId
          }
          if (successFunction !== undefined) {
            successFunction(companyPaymentData)
          }
        },
        function (data) {
          if (errorFunction !== undefined) {
            errorFunction(data)
          }
        })
    }

    paymentServiceSrv.getNeedToUpdateMangopay = function (successFunction, errorFunction) {
      let paymentServiceResource = new PaymentService_Resource();

      paymentServiceResource.$getNeedUpdateMangopay({},
        function (data) {
          if (successFunction !== undefined) {
            successFunction(data);
          }
        },
        function (data) {
          if (errorFunction !== undefined) {
            errorFunction(data);
          }
        });
    }

    paymentServiceSrv.enrollUser = function (){
        let paymentServiceResource = new PaymentService_Resource();

        paymentServiceResource.$enrollUser({},
            function (data){
                if(data.redirectUrl) {
                    $window.location.href = data.redirectUrl;
                }
            },
            function (data){
                console.error("Could not enroll user", data)
            })
    }

    return paymentServiceSrv;
  }
])




// WEBPACK FOOTER //
// ./js/services/models/PaymentService.js